/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/* prettier-ignore */


/**
 * 1 = Current Rates, 2 = Current and future rates, 3 = All Rates
 */
export enum RatePlanRateRequestType {
    NUM_1 = 1,
    NUM_2 = 2,
    NUM_3 = 3,
}